import { theme } from "../config/theme";

const styles = {
  paper: {
    width: 1080,
    margin: "auto",
    overflow: "auto",
    boxShadow: "0 1px 3px 0 #dce1e6",
    height: "calc(100vh - 156px)"
  },
  searchBar: {},
  searchInput: {
    "fontSize": `${theme.typography.fontSize}px`,
    "borderRadius": "0",

    "& input": {
      padding: "0"
    },

    "& fieldset": {
      border: "none",
      padding: "0"
    }
  },
  block: {
    display: "block"
  },
  addUser: {
    padding: "5px 10px",
    fontSize: "12px",
    borderRadius: "3px",
    fontWeight: "600",
    marginRight: "-10px"
  },
  contentWrapper: {
    height: "100%"
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  paperWhite: {
    backgroundColor: `${theme.palette.background.paper}`,
    border: "none",
    outline: 0,
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.06)",
    borderRadius: "5px",
    padding: `${theme.spacing(2, 4, 3)}`
  },
  table: {
    "& .MuiTableHead-root": {
      top: "46px"
    }
  }
};

export { styles };
